export default class GapiTool {

    constructor(input, update_gps_data) {
        this.input = input;
        this.update_gps_data = update_gps_data;
        var init_interval = setInterval(()=>{
            if (window.gapi_loaded == true && window.gis_loaded == true) {
                if (!this.init) {
                    this.on_gapi_load();
                    this.on_gis_load();
                    this.init = true;
                }
                else if (this.gapiInited && this.gisInited){
                    this.ready_callback();
                    clearInterval(init_interval);
                }
            }
        },100);
        return this;
    }

    update_input = (input) => {
        this.input = input;
    }

    gapi_init = () =>{
        const that = this;
        gapi.client.init({
            // NOTE: OAuth2 'scope' and 'client_id' parameters have moved to initTokenClient().
        })
        .then(function() {  // Load the analytics API discovery document.
            gapi.client.load('https://analyticsdata.googleapis.com/$discovery/rest?version=v1beta');
            that.gapiInited=true;
        });
    }

    on_gapi_load = () => {
        gapi.load('client', this.gapi_init)
    }

    on_gis_load = () =>{
        this.tokenClient = google.accounts.oauth2.initTokenClient({
            client_id: '410523997103-9krishg9631u57c4m3bojaf72ve5jgq4.apps.googleusercontent.com',
            scope: 'https://www.googleapis.com/auth/analytics.readonly',
            callback: '',  // defined at request time
        });
        this.gisInited=true;
    }

    handle_file_upload = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.addEventListener('load', this.handle_file_read);
        reader.readAsText(file);
    }


    handle_file_read = (event) => {
        const file_contents = event.target.result;
        this.display_results({result:JSON.parse(file_contents)});
    };

    ready_callback = () => {};

    display_results = (response) => {
        this.update_gps_data(response.result);
        
        let formatted_json = JSON.stringify(response.result, null, 2);
        console.log(formatted_json);
        localStorage.setItem("ga_gps_json", formatted_json);
    }

    retrieve_analytics = () => {

        

        const that = this;
        this.input = this.get_input();
        const input = this.input;
        console.log(this.input);

        that.tokenClient.callback = (resp) => {
        if (resp.error !== undefined) {
            throw(resp);
        }
        // GIS has automatically updated gapi.client with the newly issued access token.
        console.log('gapi.client access token: ' + JSON.stringify(gapi.client.getToken()));

        gapi.client.request({
            path: '/v4/reports:batchGet',
            root: 'https://analyticsreporting.googleapis.com/',
            method: 'POST',
            body: {
                reportRequests: [
                    {
                    viewId: input.gapi_view_id,
                    dateRanges: [
                        {
                        startDate: input.gapi_date_start,
                        endDate: input.gapi_date_end
                        }
                    ],
                    metrics: [
                        {
                        expression: 'ga:users'
                        }
                    ],
                    dimensions: [
                        {
                        name: 'ga:dimension1',
                        },{
                        name: 'ga:dimension2',
                        },{
                        name: 'ga:dateHourMinute'
                        },{
                        name: 'ga:mobileDeviceInfo'
                        },{
                        name: 'ga:browserVersion'
                        },{
                        name: 'ga:sessionCount'
                        },{
                        name: 'ga:operatingSystemVersion'
                        },{
                        name: 'ga:pagePath'
                        },
                    ],
                    pageSize: 100000,
                    }
                ]
            }
        }).then(this.display_results, console.error.bind(console));
        }
    
        // Conditionally ask users to select the Google Account they'd like to use,
        // and explicitly obtain their consent to fetch their Calendar.
        // NOTE: To request an access token a user gesture is necessary.
        if (gapi.client.getToken() === null) {
        // Prompt the user to select a Google Account and asked for consent to share their data
        // when establishing a new session.
        that.tokenClient.requestAccessToken({prompt: 'consent'});
        } else {
        // Skip display of account chooser and consent dialog for an existing session.
        that.tokenClient.requestAccessToken({prompt: ''});
        }
    }


}